import { Stack, Theme, Typography, useTheme } from "@mui/material";
import { ROUTES } from "helpers/routes";
import { Link } from "react-router-dom";

const AppLogo: React.FC<{ collapsed?: boolean }> = ({ collapsed = false }) => {
  const theme: Theme = useTheme();

  return (
    <Link
      to={ROUTES.HOME}
      style={{
        textDecoration: "none",
        color: theme.palette.common.white,
      }}
    >
      <Stack alignItems="center">
        <img
          src="/logo.png"
          alt="logo"
          width={150}
          height="auto"
          style={{ marginBottom: 8 }}
        />
        <Typography
          noWrap
          fontWeight={theme.typography.fontWeightMedium}
          fontSize={14}
          style={{ margin: 0, userSelect: "none" }}
        >
          Ho Chi Minh City
        </Typography>
        <Typography
          noWrap
          fontSize={12}
          style={{ margin: 0, userSelect: "none" }}
        >
          by Genesia
        </Typography>
      </Stack>
    </Link>
  );
};

export default AppLogo;
